import { connect } from 'react-redux';
import { CommanderThunkDispatch } from '@mews-commander/types';
import { IconName, Button } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Reservation } from '@mews-commander/data-access';
import { updateLockedStatus } from '@mews-commander/legacy-entities/src/ducks/reservations';
import { withActiveWindowLoader } from '../../../../../core';

interface DispatchProps {
    handleLockedStatusUpdate(args: { reservationIds: string[]; lockedStatus: boolean }): void;
}
interface OwnProps {
    reservations: Reservation[];
    refetchGroup: () => void;
}
type Props = DispatchProps & OwnProps;

const LockAllButton = ({ reservations, handleLockedStatusUpdate }: Props) => {
    const areAllLocked = reservations.every((reservation) => reservation.assignedResourceLocked);
    const textKey = areAllLocked ? TextKey.Unlock : TextKey.Lock;
    const handleClick = () =>
        handleLockedStatusUpdate({ reservationIds: reservations.map((r) => r.id), lockedStatus: !areAllLocked });
    if (reservations.length === 0) {
        return null;
    }

    return (
        <Button
            variant="ghost"
            icon={areAllLocked ? IconName.Lock : IconName.Unlock}
            onClick={handleClick}
            type="submit"
        >
            <LocalizedText textKey={textKey} />
        </Button>
    );
};

export default connect<{}, DispatchProps, OwnProps>(
    undefined,
    (dispatch: CommanderThunkDispatch, { refetchGroup }) => ({
        handleLockedStatusUpdate: async (args) =>
            withActiveWindowLoader(() => dispatch(updateLockedStatus(args))).then(refetchGroup),
    })
)(LockAllButton);
